import React, { createContext, useContext } from 'react';
import type { AnalyticsEventParameters } from './analyticsController';
import type { AnalyticsEventName } from './analyticsEvents';

export interface AnalyticsContextValue {
  trackEvent: (eventName: AnalyticsEventName, parameters?: AnalyticsEventParameters) => void;
  openCookieSettings: () => void;
  cookieSettingsAvailable: boolean;
}

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);

/** Reopens the consent dialog; renders `fallback` where analytics is off or absent. */
export const CookieSettingsButton: React.FC<{
  className?: string;
  fallback?: React.ReactNode;
}> = ({ className, fallback = null }) => {
  const context = useContext(AnalyticsContext);
  if (!context?.cookieSettingsAvailable) return <>{fallback}</>;
  return (
    <button type="button" className={className} onClick={context.openCookieSettings}>
      Cookie settings
    </button>
  );
};
